<template>
  <v-container fluid>
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn fab bottom right fixed color="primary"
          v-bind="attrs" v-on="on" @click="dialogForm = {action: 'Create User', showForm: true, user: {}}">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>Create User</span>
    </v-tooltip>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          :no-data-text="'No data found'"
          :no-results-text="'No results found'"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :loading="loading"
        :sort-by="['id']"
        :sort-desc="[true]"
      >
        <template v-slot:item.edit="{ item }">
          <v-btn icon @click="dialogForm = {action: 'Edit User', showForm: true, user: Object.assign(item)}">
            <v-icon>mdi-account-edit</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.update_password="{ item }">
          <v-btn icon @click="dialogForm = {action: 'Update Password', showForm: true, user: Object.assign(item)}">
            <v-icon>mdi-pencil-lock</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.is_active="{ item }">
          <span>{{ item.is_active ? 'Active' : 'Inactive'}}</span>
        </template>
        <template v-slot:item.role="{ item }">
          <span class="text-capitalize">{{ item.role }}</span>
        </template>
        <template v-slot:item.is_tfa_enabled="{ item }">
          <v-icon :color="item.is_tfa_enabled ? 'success' : 'error'">
            {{ item.is_tfa_enabled ? 'mdi-check-circle' : 'mdi-close-circle' }}
          </v-icon>
        </template>
        <template v-slot:item.reset_tfa="{ item }">
          <v-btn icon @click="openResetTfaDialog(item)">
            <v-icon color="warning">mdi-refresh</v-icon>
          </v-btn>
        </template>
        <template v-slot:progress>
          <div class="full-width text-center ma-4">
            <v-progress-circular
              indeterminate
              color="primary"
              :size="60"
              :width="5"
            ></v-progress-circular>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <user-form 
      :user="dialogForm.user"
      :isAdmin="true"
      :action="dialogForm.action"
      :showForm="dialogForm.showForm"
      @formSubmitted="resetDialog();getUsers();"
      @closeDialog="resetDialog()" />

    <!-- Reset 2FA Dialog -->
    <v-dialog v-model="resetTfaDialog.show" max-width="500" persistent>
      <v-card>
        <v-card-title class="text-h5 primary white--text">
          Reset Two-Factor Authentication
        </v-card-title>
        <v-card-text class="pt-4">
          <p class="mb-4">
            To reset 2FA for <strong>{{ resetTfaDialog.userEmail }}</strong>, please enter the email address to confirm:
          </p>
          <v-text-field
            v-model="resetTfaDialog.confirmEmail"
            label="Enter Email Address"
            placeholder="Enter email to confirm"
            outlined
            :rules="[rules.required, rules.email]"
            prepend-inner-icon="mdi-email"
            @keyup.enter="confirmResetTfa"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeResetTfaDialog">Cancel</v-btn>
          <v-btn color="primary" @click="confirmResetTfa" :loading="resetTfaDialog.loading" :disabled="resetTfaDialog.loading">
            Reset 2FA
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import UserForm from './blocks/UserForm';
  import rules from '../../utilities/validator';

  export default {
    name: 's-user',
    components: {
      UserForm,
    },
    data() {
      return {
        rules,
        dialogForm: {
          showForm: false,
          action: '',
          user: {},
        },
        search: '',
        loading: false,
        resetTfaDialog: {
          show: false,
          userEmail: '',
          confirmEmail: '',
          userId: null,
          loading: false,
        },
        headers: [
          {text: 'Id', value: 'id', align: 'start'},
          {text: 'Name', value: 'name', align: 'center'},
          {text: 'Email', value: 'email', align: 'center'},
          {text: 'Mobile', value: 'mobile', align: 'center'},
          {text: 'Role', value: 'role', align: 'center'},
          {text: 'Is Active', value: 'is_active', align: 'center'},
          {text: '2FA Activated', value: 'is_tfa_enabled', align: 'center'},
          {text: 'Reset 2FA', value: 'reset_tfa', align: 'center'},
          {text: 'Edit', value: 'edit', align: 'center'},
          {text: 'Update Password', value: 'update_password', align: 'center'},
        ],
        items: [],
      };
    },
    methods: {
      resetDialog() {
        this.dialogForm = {showForm: false, action: '', user: {}};
      },
      getUsers() {
        this.loading = true;
        this.$api.users.index()
          .then((response) => {
            this.items = response.users;
            this.loading = false;
          }).catch((err) => {
            this.loading = false;
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          });
      },
      openResetTfaDialog(item) {
        this.resetTfaDialog = {
          show: true,
          userEmail: item.email,
          confirmEmail: '',
          userId: item.id,
          loading: false,
        };
      },
      closeResetTfaDialog() {
        this.resetTfaDialog = {
          show: false,
          userEmail: '',
          confirmEmail: '',
          userId: null,
          loading: false,
        };
      },
      confirmResetTfa() {
        if (!this.resetTfaDialog.confirmEmail) {
          this.$store.dispatch('setAlert', {
            status: 'error',
            show: true,
            message: 'Please enter the email address',
          });
          return;
        }

        if (this.resetTfaDialog.confirmEmail !== this.resetTfaDialog.userEmail) {
          this.$store.dispatch('setAlert', {
            status: 'error',
            show: true,
            message: 'Email address does not match. Please enter the correct email.',
          });
          return;
        }

        this.resetTfaDialog.loading = true;
        this.$api.users.resetTfa({ email: this.resetTfaDialog.confirmEmail })
          .then((response) => {
            this.resetTfaDialog.loading = false;
            this.closeResetTfaDialog();
            this.$store.dispatch('setAlert', {
              status: 'success',
              show: true,
              message: response.message || '2FA has been reset successfully',
            });
            this.getUsers();
          }).catch((err) => {
            this.resetTfaDialog.loading = false;
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          });
      },
    },
    created() {
      if (!this.$root.hasAccess('')) {
        this.$store.dispatch('setAlert', {
          status: 'error',
          show: true,
          message: "Please contact admin to access this page",
        });
        this.$router.push({name: 'home'});
      }
      this.getUsers();
    },
  };
</script>